module.exports = __webpack_public_path__ + "media/images/area/feature/kansai/related/ja/3-47dff897be79e35dc37b9894672cd0c0.jpg";